module.exports = __webpack_public_path__ + "static/award1_202107-8096c4a4f3dfd9f1a0fdc8e173b493d0.png";